<template>
    <div>
        <vs-popup title="Escolha a ERP para Vincular o Usuário:" 
        :active.sync="isActive"
        @close="$emit('isActiveFalse')"
        style="border-radius: 10px !important;"
        id="erprootmodal"
        class="sizePopup"
        >

            <vs-table 
            ref="table" 
            :data="listERPs" 
            id="tableData"
            :sst="true"
            style="padding: 0 !important;"
            v-model="selected"
            noDataText="Sem dados disponíveis"
            >  
                <div>
                    <vs-dropdown
                        vs-trigger-click
                        class="cursor-pointer mr-4"
                    >
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">
                                {{ currentPage * maxPerPage - (maxPerPage - 1) }} -
                                {{
                                    listERPs.length - currentPage * maxPerPage > 0
                                        ? currentPage * maxPerPage
                                        : listERPs.length
                                }} of {{ listERPs.length }}
                            </span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="maxPerPage=4">
                                <span>4</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="maxPerPage=10">
                                <span>10</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="maxPerPage=15">
                                <span>15</span>
                                </vs-dropdown-item>
                                <vs-dropdown-item @click="maxPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th class="text-base" sort-key="corporate_name" style="width: 75%; padding-left: 9%;">
                        Nome
                    </vs-th>
                </template>


                <template slot-scope="{data}">
                    <tbody> 
                        <vs-tr 
                            :data="tr" 
                            :key="tr.id"
                            :id="tr.id"
                            v-for="(tr, index) in listERPs.slice(previousNumberRegister, nextNumberRegister)"
                        >
                            <vs-td :data="tr.corporate_name" style="border-top-left-radius: 8px; border-bottom-left-radius: 8px; padding-left: 9%;">
                                <p class="text-left">
                                    {{ tr.corporate_name }}
                                </p>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>

            <vs-button
                color="primary"
                type="filled"
                class="align-right mr-5 mb-4"
                style="float: right;"
                @click.prevent="openErpUserModal()"
            >
                <span>Continuar</span>
            </vs-button>

            <div class="mt-3 mr-4">
                <vs-pagination
                :total="totalPages"
                v-model="currentPage"
            />
            </div>
        </vs-popup>

        <vs-popup
        :active.sync="erpUserModal"
        @close="erpUserModal=false"
        title="Adicione o Usuário"
        >
            <vs-icon icon="keyboard_arrow_left" @click="backToErp" id="left-arrow-icon"/>
            <UserModal
            :erpUsers="erpUsers"
            :selected="selected"
            @erpUserData="erpUserData"
            />

        </vs-popup>

        <vs-popup
        :active.sync="confirmPasswordModal"
        @close="confirmPasswordModal=false"
        title="Confirme a Senha"
        >   
            <vs-icon icon="keyboard_arrow_left" style="margin-top:0;" @click="backToUsers" id="left-arrow-icon"/>
            <h5 style="margin: 5px 0 5px 36px;">Digite a senha do usuário logado</h5>

            <div id="user-confirm-password">
                <vs-input
                data-vv-validate-on="blur"
                type="password"
                name="senha"
                icon-no-border
                icon="icon icon-lock"
                icon-pack="feather"
                placeholder="Senha"
                v-model="password"
                class="mt-6"
                />
            </div>

          <div class="text-danger text-sm mt-3" style="margin-left: 13%;">
            {{ error_password }}
          </div>

            <vs-button class="mt-6" @click="confirmPassword(dataToCreate)" :disabled="!password">
                Finalizar
            </vs-button>

        </vs-popup>

    </div>
</template>

<script>
    import ERP from '@/http/requests/erp';
    import AuthJwt from '@/http/requests/auth/jwt';
    import UserConnected from '@/http/requests/user';
    import UserModal from './UserModal.vue'
    import { hasFeature } from '@/utils'

    export default {
        name: 'UserErpModal',
        components: {
            UserModal,
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            }
        },
        emits: [
            'isActiveFalse',
            'listERPs'
        ],
        data() {
            return {
                listERPs: [],
                totalPages: 0,
                currentPage: 1,
                maxPerPage: 4,
                previousNumberRegister: 0,
                nextNumberRegister: 0,
                selected: {},
                erpUserModal: false,
                erpUsers: [],
                confirmPasswordModal: false,
                password: '',
                error_password: '',
                dataToCreate: {},
                hasErpFeature: false
            }
        },
        methods: {
            async loadingData() {
                await ERP.fetch()
                .then((response) => {
                    const parsedData = response.data.data.getErp

                    this.registerLength = parsedData.length;   
                    this.totalPages = Math.ceil(this.registerLength/this.maxPerPage);
                    this.nextNumberRegister = this.maxPerPage;

                    return this.listERPs = parsedData;
                })
                .catch((error) => {
                    console.log(error)
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'Erro',
                        text: 'Houve algum erro ao carregar os dados!'
                    });
                });
            },
            openErpUserModal() {
                if (Object.keys(this.selected).length === 0) {
                    return this.$vs.notify({
                        color: 'danger',
                        title: 'ERP não selecionada!',
                        text: 'Clique sobre a ERP que deseja vincular a um usuário!'
                    });
                }
                else {
                    this.isActive = false;
                    this.$emit('isActiveFalse')
                    this.erpUserModal = true;
                }
            },
            erpUserData(dataToCreate) {
                this.erpUserModal = false;
                this.confirmPasswordModal = true
                this.dataToCreate = dataToCreate
            },
            backToErp() {
                this.erpUserModal = false; 
                this.isActive = true;
            },
            backToUsers() {
                this.erpUserModal = true;
                this.confirmPasswordModal = false;
            },
            confirmPassword(dataToCreate) {
                
                AuthJwt.login(this.user_email, this.password, false)
                .then((response => {
                    this.password = '';
                    this.$emit('erpUserData', dataToCreate);
                    this.confirmPasswordModal = false;
                }))
                .catch((error) => {this.error_password = 'Senha incorreta!'})       
            },
            getConnectedUser() {
                UserConnected.infos()
                .then((response => {
                    this.user_email = response.data.data.userInfos.email
                }))
            }
        },
        async mounted() {
            this.hasErpFeature = await hasFeature('erps')

            if (this.hasErpFeature) {
                await this.loadingData();
                await this.getConnectedUser();
                this.$emit('listERPs', this.listERPs);
            }
            
        },
        watch: {
            currentPage() {
                this.previousNumberRegister = (this.currentPage * this.maxPerPage) - this.maxPerPage;
                this.nextNumberRegister = this.currentPage * this.maxPerPage;
            },
            maxPerPage() {
                this.totalPages = Math.ceil(this.registerLength/this.maxPerPage);

                this.previousNumberRegister = (this.currentPage * this.maxPerPage) - this.maxPerPage;
                this.nextNumberRegister = this.currentPage * this.maxPerPage;

                if (this.currentPage > this.totalPages) {
                    this.currentPage = this.totalPages;
                }
            },
            password(){
                if (this.password === '') {
                    this.error_password = ''
                }
            }
        },
    }
</script>

<style>
    #erprootmodal * {
        margin: 0;
    }
    #erprootmodal html {
        line-height: 1.5;
        letter-spacing: 0.02rem;
    }
    #erprootmodal table.vs-table.vs-table--tbody-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;
        background-color: white !important;
    }
    #erprootmodal .vs-con-tbody.vs-table--tbody {
        border: 0 !important;
    }
    #erprootmodal tbody > tr {
        height: 5em;
        box-shadow: 0 4px 20px 0 rgb(0 0 0 / 5%);
    }
    #erprootmodal thead > tr {
        background-color: transparent !important;
    }
    #erprootmodal .vs-table-text {
        text-transform: uppercase;
        font-size: 12px;
    }
    #erprootmodal input.input-search.vs-table--search-input {
        height: 45px;
    }
    #left-arrow-icon {
        border: 1px solid;
        border-radius: 14px;
        cursor: pointer;
        margin-top: 11px;
        float: left;
    }
    #user-confirm-password .vs-input-primary {
        width: 75%;

    }
    #user-confirm-password {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
</style>